import getSliceRange from './getSliceRange.js';
import getTargetVolumeAndSpacingInNormalDir from './getTargetVolumeAndSpacingInNormalDir.js';
import { coreLog } from './logger.js';
const log = coreLog.getLogger('utilities', 'getVolumeSliceRangeInfo');
function getVolumeSliceRangeInfo(viewport, volumeId, useSlabThickness = false) {
    const camera = viewport.getCamera();
    const { focalPoint, viewPlaneNormal } = camera;
    const { spacingInNormalDirection, actorUID } = getTargetVolumeAndSpacingInNormalDir(viewport, camera, volumeId, useSlabThickness);
    if (!actorUID) {
        log.warn('No volume found in the viewport for the volumeId of', volumeId);
        return null;
    }
    const actorEntry = viewport.getActor(actorUID);
    if (!actorEntry) {
        log.warn('No actor found for with actorUID of', actorUID);
        return null;
    }
    const volumeActor = actorEntry.actor;
    const sliceRange = getSliceRange(volumeActor, viewPlaneNormal, focalPoint);
    return {
        sliceRange,
        spacingInNormalDirection,
        camera,
    };
}
export default getVolumeSliceRangeInfo;
